export default function Spinner({ size = 40, color = "currentColor", stroke = 5, className = "" }) {
  return (
    <span
      aria-hidden="true"
      className={`zi-spinner ${className}`}
      style={{ "--zi-spinner-size": `${size}px`, "--zi-spinner-color": color, "--zi-spinner-stroke": `${stroke}px` }}
    />
  );
}
